import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { Spacers } from '@styles/theme';

export const SuccessMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-bottom: ${Spacers.XXL}rem;

  ${breakpoints.desktopOrBigger} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${Spacers.LG}rem;
    padding-bottom: unset;
  }
`;
